// CUSTOM CURSOR
document.addEventListener('DOMContentLoaded', function() {
  const cursor = document.getElementById('dhq-cursor');
  if (cursor) {
    cursor.style.display = 'block';
    document.addEventListener('mousemove', function(e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    });
    document.querySelectorAll('a, button, .dhq-card').forEach(function(el) {
      el.addEventListener('mouseenter', function() { cursor.classList.add('big'); });
      el.addEventListener('mouseleave', function() { cursor.classList.remove('big'); });
    });
  }
});

// SCROLL REVEAL
document.addEventListener('DOMContentLoaded', function() {
  const reveals = document.querySelectorAll('.reveal');
  const revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(e, i) {
      if (e.isIntersecting) {
        setTimeout(function() { e.target.classList.add('visible'); }, i * 80);
        revealObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  reveals.forEach(function(el) { revealObserver.observe(el); });
});